import { render, staticRenderFns } from "./MenuWine.vue?vue&type=template&id=4a9eada8&scoped=true&"
import script from "./MenuWine.vue?vue&type=script&lang=js&"
export * from "./MenuWine.vue?vue&type=script&lang=js&"
import style0 from "./MenuWine.vue?vue&type=style&index=0&id=4a9eada8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9eada8",
  null
  
)

export default component.exports